import axios from "axios";

const apiInstance = axios.create({
  baseURL: "https://jnmdmp.jagran.com",
});

const apiService = {
  get: async (endpoint = "", params = {}, token = "") => {
    try {
      const response = await apiInstance.get(endpoint, {
        params,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  post: async (endpoint = "", data = {}, token = "") => {
    try {
      const response = await apiInstance.post(endpoint, data, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  put: async (endpoint = "", data = {}, token = "") => {
    try {
      const response = await apiInstance.put(endpoint, data, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (endpoint = "", token = "") => {
    try {
      const response = await apiInstance.delete(endpoint, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default apiService;
